var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('slider-and-input',{staticClass:"mt8",attrs:{"value":_vm.numberCount,"title":"小数保留","sliderMin":0,"sliderMax":10,"suffix":"位","inputWidth":"small"},on:{"update:value":function($event){_vm.numberCount=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }